import { render, staticRenderFns } from "./InfoPSD2Modal.vue?vue&type=template&id=7045c7c8&"
import script from "./InfoPSD2Modal.vue?vue&type=script&lang=js&"
export * from "./InfoPSD2Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports